module.exports = __webpack_public_path__ + "static/media/1arsfabcover.35260730.jpg";